export default __webpack_public_path__ + "static/media/ic-arrowdown.20906c18.svg";